import { api } from "./client";
import { toast } from 'react-toastify';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Add a new product
const lang = localStorage.getItem('lang') || 'en';

// export const addProduct = async (productData) => {
//   try {
//     const config = {
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${localStorage.getItem('token')}`,
//         'Accept-Language': lang // Set the language header
//       }
//     };

//     const response = await api.post(`${API_BASE_URL}api/products`, productData, config);

//     toast.success("Product added successfully!");
//     return {
//       success: true,
//       data: response.data,
//       error: null
//     };
//   } catch (error) {
//     console.error('Product creation failed:', error);
//     const errorMsg = error.response?.data?.message || 'Something went wrong. Please try again.';
//     toast.error(errorMsg);

//     return {
//       success: false,
//       data: null,
//       error: errorMsg
//     };
//   }
// };

// Fetch all products


export const addProduct = async (productData) => {
  try {
    const token = localStorage.getItem('token'); // MUST match your login storage key
    const res = await api.post(
      `${API_BASE_URL}api/products`,
      productData,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Accept-Language': lang,
        },
      }
    );

    toast.success(window.translate('Product added successfully!'));
    return { success: true, status: res.status, data: res.data, error: null };
  } catch (err) {
    const status = err?.response?.status;
    const msg =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err.message ||
      'Something went wrong. Please try again.';

    // nicer messages by status
    if (status === 401) {
      toast.error(`${window.translate("You are not logged in. Please sign in again")}`);
    } else if (status === 409) {
      // backend sends: "Product limit reached. Current X/Y."
      toast.error(msg || `${window.translate("Product limit reached.")}`);
    } else {
      toast.error(msg);
    }

    return { success: false, status, data: null, error: msg };
  }
};



export const fetchProductList = async () => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Accept-Language': lang // Set the language header
      }
    };
    const response = await api.get(`${API_BASE_URL}api/products/product-list`,config);
    // toast.success("Product list loaded!");
    return response.data;
  } catch (err) {
    console.error("Failed to fetch products", err);
    toast.error(`${window.translate("Failed to fetch products. Please try again")}`);
    return [];
  }
};

// Update a product by ID
export const updateProduct = async (productId, data) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Accept-Language': lang // Set the language header
      }
    };
    const response = await api.put(`${API_BASE_URL}api/products/${productId}`, data, config);
    // toast.success("Product updated successfully!");
    return response.data;
  } catch (error) {
    console.error("Failed to update product:", error);
    const msg = error.response?.data?.message || `${window.translate("Failed to update product.")}`;
    toast.error(msg);
    throw error;
  }
};

// Delete a product by ID
// export const deleteProduct = async (productId) => {
//   try {
//     const config = {
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${localStorage.getItem('token')}`,
//         'Accept-Language': lang // Set the language header
//       }
//     };
//     const response = await api.delete(`${API_BASE_URL}api/products/${productId}`,config);
//     toast.success(response.data.message || `${window.translate("Product deleted successfully!")}`);
//     return true;
//   } catch (error) {
//     const msg = error.response?.data?.message || `${window.translate("Failed to delete product.")}`;
//     console.error("Delete error:", error);
//     toast.error(msg);
//     return false;
//   }
// };
// export const deleteProduct = async (productId) => {
//   const t = (s) => (window?.translate ? window.translate(s) : s);
//   const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
//   const token = localStorage.getItem("token");

//   // helper: read server i18n or plain string
//   const readMsg = (raw) => {
//     if (Array.isArray(raw)) {
//       const hit = raw.find((m) => m && typeof m === "object" && m[lang]);
//       if (hit) return String(hit[lang]);
//       const first = raw.find((m) => m && typeof m === "object");
//       if (first) return String(Object.values(first)[0] || "");
//     }
//     return typeof raw === "string" ? raw : "";
//   };

//   try {
//     const response = await api.delete(
//       `${API_BASE_URL}api/products/${productId}`,
//       {
//         headers: {
//           "Accept-Language": lang,
//           ...(token ? { Authorization: `Bearer ${token}` } : {}),
//         },
//       }
//     );

//     const serverMsg = readMsg(response?.data?.message);
//     toast.success(serverMsg || t("Product deleted successfully!"));
//     return true;
//   } catch (error) {
//     const serverErr = readMsg(error?.response?.data?.message);
//     const msg = serverErr || t("Failed to delete product");
//     console.error("Delete error:", error);
//     toast.error(msg);
//     return false;
//   }
// };

export const deleteProduct = async (productId) => {
  const t = (s) => (window?.translate ? window.translate(s) : s);
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
  const token = localStorage.getItem("token");

  try {
    await api.delete(`${API_BASE_URL}api/products/${productId}`, {
      headers: {
        "Accept-Language": lang,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    toast.success(`${t("Product deleted successfully!")}`);
    return true;
  } catch (error) {
    console.error("Delete error:", error);
    toast.error(t("Failed to delete product"));
    return false;
  }
};


// Check SKU
export const checkSkuExists = async (sku) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/products/check-sku`, {
      params: { sku },
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    return response.data.exists; // true or false
  } catch (error) {
    console.error("Error checking SKU existence:", error);
    return false;
  }
};

export const getProductById = async (productId) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/products/product-detail/${productId}`, {
      headers: {
        "Accept-Language": "en", // or "ar" dynamically
      },
    });
    return response.data.data; // contains the structured product info
  } catch (error) {
    console.error("Error fetching product by ID:", error);
    throw error.response?.data || { message: "Server error" };
  }
};

// Bulk import products

// export const bulkUploadProducts = async (items) => {
//   // Try to infer a single store for tenant hint
//   const storeIds = Array.from(
//     new Set(
//       (items || [])
//         .map((it) => it?.product?.store || it?.product?.storeId)
//         .filter(Boolean)
//         .map(String)
//     )
//   );
//   const singleStoreId = storeIds.length === 1 ? storeIds[0] : null;

//   try {
//     const { data } = await api.post(
//       `${API_BASE_URL}api/products/bulk`,
//       { items, ...(singleStoreId ? { storeId: singleStoreId } : {}) },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Accept-Language": localStorage.getItem("lang") || "en",
//           ...(singleStoreId ? { "X-Store-Id": singleStoreId } : {}),
//         },
//       }
//     );
//     toast.success(`Bulk upload finished: ${data.created} created, ${data.failed} failed.`);
//     return { success: true, data };
//   } catch (error) {
//     const msg =
//       error.response?.data?.error ||
//       error.response?.data?.message ||
//       error.message ||
//       `${window.translate("Bulk upload failed")}`;
//     toast.error(msg);
//     return { success: false, error: msg };
//   }
// };

// Bulk import products
export const bulkUploadProducts = async (items) => {
  const t = (s) => (window?.translate ? window.translate(s) : s);
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
  const timeoutMs = Number(process.env.REACT_APP_BULK_UPLOAD_TIMEOUT_MS) || 180000;
  const chunkSize = Math.max(
    1,
    Number(process.env.REACT_APP_BULK_UPLOAD_CHUNK_SIZE) || 40
  );
  const maxRetries = Math.max(
    0,
    Number(process.env.REACT_APP_BULK_UPLOAD_RETRIES) || 1
  );

  // Try to infer a single store for tenant hint
  const storeIds = Array.from(
    new Set(
      (items || [])
        .map((it) => it?.product?.store || it?.product?.storeId)
        .filter(Boolean)
        .map(String)
    )
  );
  const singleStoreId = storeIds.length === 1 ? storeIds[0] : null;

  // helper: read server i18n array or plain string
  const readMsg = (raw) => {
    if (Array.isArray(raw)) {
      const hit = raw.find((m) => m && typeof m === "object" && m[lang]);
      if (hit) return String(hit[lang]);
      const first = raw.find((m) => m && typeof m === "object");
      if (first) return String(Object.values(first)[0] || "");
    }
    return typeof raw === "string" ? raw : "";
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const isTimeoutError = (err) =>
    err?.code === "ECONNABORTED" || /timeout/i.test(String(err?.message || ""));

  const headers = {
    "Content-Type": "application/json",
    "Accept-Language": lang,
    ...(localStorage.getItem("token")
      ? { Authorization: `Bearer ${localStorage.getItem("token")}` }
      : {}),
    ...(singleStoreId ? { "X-Store-Id": singleStoreId } : {}),
  };

  const requestChunk = async (chunk, startIndex) => {
    let attempt = 0;
    while (attempt <= maxRetries) {
      try {
        const { data } = await api.post(
          `${API_BASE_URL}api/products/bulk`,
          { items: chunk, ...(singleStoreId ? { storeId: singleStoreId } : {}) },
          {
            headers,
            timeout: timeoutMs,
          }
        );

        const results = Array.isArray(data?.results)
          ? data.results.map((r) => ({
              ...r,
              index:
                typeof r?.index === "number" ? r.index + startIndex : r?.index,
            }))
          : [];

        return {
          created: Number.isFinite(data?.created) ? data.created : 0,
          failed: Number.isFinite(data?.failed) ? data.failed : 0,
          results,
        };
      } catch (err) {
        if (!isTimeoutError(err) || attempt >= maxRetries) {
          throw err;
        }
        attempt += 1;
        await sleep(1000 * attempt);
      }
    }

    return { created: 0, failed: chunk.length, results: [] };
  };

  try {
    const safeItems = Array.isArray(items) ? items : [];
    const aggregate = { created: 0, failed: 0, results: [] };

    for (let start = 0; start < safeItems.length; start += chunkSize) {
      const chunk = safeItems.slice(start, start + chunkSize);
      const chunkRes = await requestChunk(chunk, start);
      aggregate.created += chunkRes.created;
      aggregate.failed += chunkRes.failed;
      if (chunkRes.results.length) {
        aggregate.results.push(...chunkRes.results);
      }
    }

    // translated success toast
    toast.success(
      `${t("Bulk upload finished")}: ${aggregate.created} ${t("created")}, ${aggregate.failed} ${t("failed")}.`
    );

    return { success: true, data: aggregate };
  } catch (error) {
    const timeoutMsg = isTimeoutError(error)
      ? t("Bulk upload timed out. Please try again with fewer rows.")
      : "";
    const serverErr =
      readMsg(error?.response?.data?.error) ||
      readMsg(error?.response?.data?.message);
    const msg = timeoutMsg || serverErr || t("Bulk upload failed");
    console.error("Bulk upload error:", error);
    toast.error(msg);
    return { success: false, error: msg };
  }
};

// helper (you already have `api` axios instance)
export async function uploadCatalogImage(dataUrl, desiredName) {
  const currentLang = (localStorage.getItem("lang") || "en")
    .toLowerCase()
    .startsWith("ar")
    ? "ar"
    : "en";
  const translated =
    typeof window !== "undefined" && window?.translate
      ? window.translate("Image uploaded successfully")
      : "";
  const successMessage =
    currentLang === "ar"
      ? translated && translated !== "Image uploaded successfully"
        ? translated
        : "تم رفع الصورة بنجاح"
      : translated || "Image uploaded successfully";

  const { data } = await api.post(
    `${API_BASE_URL}api/uploads/catalog-image`,
    { dataUrl, desiredName },
    {
      headers: {
        "Accept-Language": currentLang,
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  if (!data?.success) throw new Error(data?.message || "Upload failed");
  toast.success(successMessage);
  return data; // { success, key: "/catalog/xxx.jpg", url, contentType }
}
